var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#f5f5f5"}},[_c('banner'),_c('company-profile'),_c('supporting-institutions'),_c('culture'),_c('growth-process'),_c('development')],1)}
var staticRenderFns = []

export { render, staticRenderFns }